import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full border-y border-ink-800 bg-ink-900 py-16" aria-labelledby="garantia" data-id="element-117" data-mp="4uqdmw6js2tb">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-start gap-6 px-4 sm:flex-row sm:items-center sm:px-6" data-id="element-118" data-mp="9ttgqb2yvyyn">
        <span className="flex h-16 w-16 flex-none items-center justify-center rounded-2xl border border-gold bg-ink-950 text-gold" data-id="element-119" data-mp="eu8w186t7gj9">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-120" data-mp="jqg2r3714w29" />
        </span>
        <div data-id="element-121" data-mp="nsb2w4d853eg">
          <h2 id="garantia" className="font-display text-2xl font-900 uppercase tracking-wide text-white" style={{
          fontSize: "20px"
        }} data-id="element-122" data-mp="ns1aka4pik5l">
            GARANTÍA 7 DÍAS — 
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-slate-300" style={{
          fontSize: "14px"
        }} data-id="element-123" data-mp="xjfdyszs4440">
            Abres los tomos. Los aplicas en tu proyecto. Si en 7 días no es exactamente lo que
            esperabas: devolución del 100% sin formularios, sin trámites, sin esperas. Un solo
            mensaje y listo.
          </p>
          <p className="mt-2 text-sm text-slate-500" data-id="element-124" data-mp="20su412tqqnr0">Tasa de devoluciones: menos del 1%.</p>
        </div>
      </div>
    </section>;
}